import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  baseAssignmentsActions,
  baseAssignmentsSelectors,
  BaseAvailableFileTypeEnum,
  BaseAvatarSize,
  BaseButtonSize,
  BaseCoreState,
  BaseModalService,
  ProfileDocumentResponse,
} from 'base';

@Component({
  selector: 'base-customer-candidate-document',
  templateUrl: './base-customer-candidate-document.component.html',
})
export class BaseCustomerCandidateDocumentComponent implements OnInit, OnDestroy {
  @Input() document: ProfileDocumentResponse & { categoryLabel?: string };
  @Input() assignmentId: number;
  @ViewChild('documentViewerTemplate') documentViewerTemplate: ElementRef;

  avatarSize = BaseAvatarSize;
  buttonSize = BaseButtonSize;
  activeDocumentSrc: Blob;
  activeDocument: (ProfileDocumentResponse & { categoryLabel?: string }) | undefined;
  documentViewerModalRef: NgbModalRef;
  baseAvailableFileTypes = BaseAvailableFileTypeEnum;

  private destroy$ = new Subject();

  constructor(private store: Store<BaseCoreState>, private modalService: BaseModalService) {}

  ngOnInit() {
    this.store
      .select(baseAssignmentsSelectors.getDocumentView)
      .pipe(
        takeUntil(this.destroy$),
        filter((state) => !!state.data),
        map((state) => state.data)
      )
      .subscribe((document) => {
        if (this.activeDocument && this.activeDocument.id === this.document.id) {
          this.openDocumentViewer(document as Blob);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  downloadDocument(openInModal = false): void {
    this.activeDocument = this.document;
    this.store.dispatch(
      baseAssignmentsActions.downloadCustomerCandidateDocument({
        payload: {
          assignment: this.assignmentId,
          document: this.document.id,
          documentType: this.document.type,
          openInModal,
        },
      })
    );
  }

  private openDocumentViewer(document: Blob): void {
    this.activeDocumentSrc = document;
    this.documentViewerModalRef = this.modalService.open(
      {
        bodyTemplate: this.documentViewerTemplate,
        cancelButtonDisplayed: false,
        okButtonDisplayed: false,
        hideHeader: true,
        hideFooter: true,
      },
      { size: 'xl' }
    );
    this.documentViewerModalRef.result.then(
      () => this.cleanDocumentViewer(),
      () => this.cleanDocumentViewer()
    );
  }

  private cleanDocumentViewer() {
    this.store.dispatch(baseAssignmentsActions.clearDocumentView());
    this.activeDocument = undefined;
  }
}
